// ResetPasswordPage: Öffentliche Zielseite des „Passwort vergessen"-Mail-Links
// (/reset-password?token=…). Setzt das neue Passwort und meldet bei Erfolg direkt an.
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PASSWORD_HINT } from '../components/AuthPage';
import { apiClient } from '../api/apiClient';
import { errorMessage } from '../api/errorMessage';
import '../components/AuthPage.css';

function ResetPasswordPage({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  // Ungültiger/abgelaufener Link ist kein Feld-Fehler: statt des Formulars erscheint
  // der Weg zurück zum Anfordern eines neuen Links.
  const [tokenInvalid, setTokenInvalid] = useState(!token);

  const goToForgotView = () => navigate('/', { state: { authView: 'forgot' } });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== newPasswordConfirm) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      const { data } = await apiClient.post('/api/auth/reset-password', { token, newPassword, newPasswordConfirm });

      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLoginSuccess(data.user, data.token);
    } catch (err) {
      if (err.code === 'RESET_TOKEN_INVALID') {
        setTokenInvalid(true);
      } else {
        setError(errorMessage(err, 'Zurücksetzen fehlgeschlagen.'));
      }
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>CoMana</h1>

        {tokenInvalid ? (
          <div className="auth-form">
            <h2>Link nicht mehr gültig</h2>
            <p className="form-hint">
              Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordere einfach
              einen neuen an — das dauert nur einen Moment.
            </p>
            <button type="button" className="auth-button" onClick={goToForgotView}>
              Neuen Link anfordern
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <h2>Neues Passwort setzen</h2>

            {error && <div className="auth-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="reset-password">Neues Passwort:</label>
              <input
                id="reset-password"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="••••••"
                required
              />
              <p className="form-hint">{PASSWORD_HINT}</p>
            </div>

            <div className="form-group">
              <label htmlFor="reset-password-confirm">Passwort bestätigen:</label>
              <input
                id="reset-password-confirm"
                type="password"
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
                placeholder="••••••"
                required
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Wird gespeichert...' : 'Passwort speichern'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
